import { render, staticRenderFns } from "./MarkBookNewAssesment.vue?vue&type=template&id=57d9514c"
import script from "./MarkBookNewAssesment.vue?vue&type=script&lang=js"
export * from "./MarkBookNewAssesment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports